/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const districtOptions = [
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    ward,
    homeNumber,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    agencyContract,
    agencyContractDate,
    documents,
    documentsDate,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId1.name}
            label={taxId1.label}
            value={values.taxId1}
            error={errors.taxId1 && touched.taxId1}
            success={values.taxId1?.toString().length > 0 && !errors.taxId1}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province.type}
            label={province.label}
            name={province.name}
            value={values.province}
            placeholder={province.placeholder}
            error={errors.province && touched.province}
            success={values.province.length > 0 && !errors.province}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={ward.type}
            label={ward.label}
            name={ward.name}
            value={values.ward}
            placeholder={ward.placeholder}
            error={errors.ward && touched.ward}
            success={values.ward.length > 0 && !errors.ward}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={homeNumber.name}
            label={homeNumber.label}
            value={values.homeNumber}
            error={errors.homeNumber && touched.homeNumber}
            success={values.homeNumber?.toString().length > 0 && !errors.homeNumber}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone.name}
            label={phone.label}
            value={values.phone}
            error={errors.phone && touched.phone}
            success={values.phone?.toString().length > 0 && !errors.phone}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax.name}
            label={fax.label}
            value={values.fax}
            error={errors.fax && touched.fax}
            success={values.fax?.toString().length > 0 && !errors.fax}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email.name}
            label={email.label}
            value={values.email}
            error={errors.email && touched.email}
            success={values.email?.toString().length > 0 && !errors.email}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyContract.name}
            label={agencyContract.label}
            value={values.agencyContract}
            error={errors.agencyContract && touched.agencyContract}
            success={values.agencyContract?.toString().length > 0 && !errors.agencyContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={agencyContractDate.name}
            label={agencyContractDate.label}
            error={errors.agencyContractDate && touched.agencyContractDate}
            success={values.agencyContractDate?.toString().length > 0 && !errors.agencyContractDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={documents.name}
            label={documents.label}
            value={values.documents}
            error={errors.documents && touched.documents}
            success={values.documents?.toString().length > 0 && !errors.documents}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={documentsDate.name}
            label={documentsDate.label}
            error={errors.documentsDate && touched.documentsDate}
            success={values.documentsDate?.toString().length > 0 && !errors.documentsDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
